import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputErrorComponent } from './input-error.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule
  ],
  exports: [InputErrorComponent],
  declarations: [InputErrorComponent]
})
export class InputErrorModule { }


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/input-error/input-error.module.ts